import axiosCall from './interceptor';
import URL, { buildQueryParams } from '../helper';
import { saveByteArray } from '../javascript';

async function parseMultipartMixedToFormData(response) {
  const contentType = response.headers['content-type'];
  console.log({ contentType });
  const boundaryMatch = contentType.match(/boundary=([^;]+)/);
  if (!boundaryMatch) {
    throw new Error('Boundary not found in Content-Type header.');
  }
  const boundary = boundaryMatch[1];

  const text = await response.data;
  const parts = text.split(`--${boundary}`).filter(part => part.trim() !== '' && part.trim() !== '--');

  const map = new Map();

  for (const part of parts) {
    const lines = part.split('\r\n').filter(line => line.trim() !== '');
    const contentDispositionLine = lines.find(line => line.startsWith('Content-Disposition:'));
    const contentTypeLine = lines.find(line => line.startsWith('Content-Type:'));

    if (contentDispositionLine) {
      const nameMatch = contentDispositionLine.match(/name="([^"]+)"/);
      const filenameMatch = contentDispositionLine.match(/filename="([^"]+)"/);

      const name = nameMatch ? nameMatch[1] : null;
      const filename = filenameMatch ? filenameMatch[1] : null;

      // The actual data starts after the headers
      const dataIndex = lines.findIndex(line => line.trim() === '') + 1;
      const data = lines.slice(dataIndex).join('\r\n');

      if (name) {
        /*if (filename) {
          const contentType = contentTypeLine.split(':')[1].trim();
          // Assuming binary data for files, adjust content type as needed
          const blob = new Blob([data], { type: contentType });
          formData.append(name, data, filename);
        } else {
          formData.append(name, data);
        }*/
        const actualContents = lines.slice(3).join('\r\n');
        map.set(name, actualContents);
      }
    }
  }
  return map;
}

export const importFileToPseudo = async (fileData) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}pdf/extract`;
  let form = new FormData();
  form.append('file', fileData);
  form.append('recipient', 'single');

  // let response = await axiosCall('post', url, form, true, true, true);
  let response = await axiosCall('post', url, form);
  console.log({ response });

  const files = await parseMultipartMixedToFormData(response);
  let images = [];
  if (files.get('images.json')) {
     const imageJSON = JSON.parse(files.get('images.json'));
     images = imageJSON.map(json => {
       const imageContent = atob(json.data);
       const buffer = new ArrayBuffer(imageContent.length);
       const view = new Uint8Array(buffer);

       for (let n = 0; n < imageContent.length; n++) {
         view[n] = imageContent.charCodeAt(n);
       }
       const type = 'image/png';
       const blob = new Blob([buffer], { type });
       return new File(
         [blob],
         json.fileName,
         { type }
       );
     })
  }
  return [
    files.get('design_pseudo.txt'),
    ...images
  ];
};

export const updateEnableHybridMailMenu = async payload => {
  const url = `${URL.BASE_URL}config/hybridMailEnable`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};

export const updateHybridMailEditable = async payload => {
  const url = `${URL.BASE_URL}config/hybridMailEditable`;
  let response = await axiosCall('put', url, payload);
  return response.data;
};

export const updateEnvelopeAddress = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/modify-address`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}


export const detectAndSplit = async ({batchUUID}) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/fileUploaded?batchId=${batchUUID}`;
  let response = await axiosCall('post', url);
  return response.data;
};

export const getDocument = async ({ batchDetailId, fileName }) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/split/download?batchDetailId=${batchDetailId}&fileName=${fileName}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const previewPdf = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/previewHybridPDF`;
  let response = await axiosCall('post', url, payload, true, false, true);
  if (response?.status === 200) {
    return {
      status: response?.status,
      url: saveByteArray(payload.fileName, response.data, false),
    };
  }
};

export const getAllHybridMailBatches = async payload => {
  const query = buildQueryParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/batches${query ? `?${query}` : ''}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const updateHybridBatch = async values => {
  const params = new URLSearchParams(
    Object.entries(values).filter(
      ([_, value]) => value !== undefined && value !== '',
    ),
  );
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/metadataUpdate?${params}`;
  let response = await axiosCall('patch', url);
  return response.data;
};

export const getHybridBatchList = async ({
  hybridBatchId,
  page,
  limit = 10,
  desc = false,
  text,
  status,
  exclusionFilter,
  statusNotIn,
  addressValid,
  addressPositionValid,
  statusIn
}) => {
  const query = new URLSearchParams({
    hybridBatchId,
    page,
    limit,
    desc,
    ...(text != null && { text }),
    ...(status != null && { status }),
    ...(exclusionFilter && { exclusionFilter }),
    ...(statusNotIn && { statusNotIn }),
    ...(addressValid != null && { addressValid }),
    ...(addressPositionValid !=null && { addressPositionValid }),
    ...(statusIn && {statusIn})
  }).toString();
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/letterInfo${query ? `?${query}` : ''}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const sendLetter = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/sendLetter`;
  let response = await axiosCall('patch', url, payload);
  return response.data;
};

export const sendSelectedLetters = async payload => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/sendSelectedLetters`;
  let response = await axiosCall('patch', url, payload);
  return response.data;
};

export const getSplitDocument = async ({ batchId, fileName }) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/split/download?batchId=${batchId}&fileName=${fileName}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const downloadHybridLetter = async (finalDownloadUrl) => {
  const url = `${URL.AUTH_BASE_URL}${finalDownloadUrl}`;
  let response = await axiosCall('get', url, {}, true, false, true);
  return response.data;
};

export const submitBatch = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/submitBatch`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const uploadFileToBlob = async (sasURI, file, cancelToken, storageType = 'azure') => {
  const headers = {
    'Content-Type': file.type || 'application/pdf',
  };
  if (storageType === 'azure') {
    headers['x-ms-blob-type'] = 'BlockBlob';
  }
  return await axiosCall('put', sasURI, file, false, false, false, false, false, {
    headers,
    ...(cancelToken && { cancelToken }),
  });
};

export const uploadBlock = async (sasURI, blockId, chunk, cancelToken, storageType = 'azure', partNumber) => {
  let url = sasURI;
  const headers = {
    'Content-Type': 'application/octet-stream',
  };

  if (storageType === 'azure') {
    url = `${sasURI}&comp=block&blockid=${encodeURIComponent(blockId)}`;
    headers['x-ms-blob-type'] = 'BlockBlob';
  } else if (storageType === 'aws') {
    // For AWS, we assume the sasURI already contains uploadId or is a pre-signed URL for a part
    // If not, we append partNumber. Usually, for AWS multipart, you need partNumber and uploadId.
    // If the backend provides a single uploadUrl, it might be expecting partNumber as a query param.
    url = `${sasURI}${sasURI.includes('?') ? '&' : '?'}partNumber=${partNumber}`;
  }

  return await axiosCall('put', url, chunk, false, false, false, false, false, {
    headers,
    ...(cancelToken && { cancelToken }),
  });
};

export const commitBlockList = async (sasURI, blockListXml, fileType, cancelToken, storageType = 'azure', blockIds = []) => {
  if (storageType === 'aws') {
    // For AWS, completing a multipart upload typically requires a POST with a body containing ETags.
    // However, if the user says "dont change anything" for Azure and "do the changes" for AWS,
    // and given the existing code structure, I will implement a placeholder or POST for AWS.
    // Usually, AWS CompleteMultipartUpload is a POST.
    const url = `${sasURI.split('?')[0]}${sasURI.includes('?') ? '?' + sasURI.split('?')[1] : ''}`;
    const body = {
      parts: blockIds.map((etag, index) => ({
        ETag: etag,
        PartNumber: index + 1
      }))
    };
    return await axiosCall('post', url, body, false, false, false, false, false, {
      headers: { 'Content-Type': 'application/json' },
      ...(cancelToken && { cancelToken })
    });
  }

  const url = `${sasURI}&comp=blocklist`;
  return await axiosCall('put', url, blockListXml, false, false, false, false, false, {
    headers: {
      'Content-Type': 'application/xml',
      'x-ms-blob-content-type': fileType,
    },
    ...(cancelToken && { cancelToken })
  });
};

export const createBatchNew = async ({ batchName, envelopeType, deliveryClass, splitType, pageCount, file }) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/createBatchNew`;
  const form = new FormData();
  form.append('batchName', batchName);
  form.append('envelopeType', envelopeType);
  form.append('deliveryClass', deliveryClass);
  form.append('splitType', splitType);
  if (pageCount !== null && pageCount !== undefined) {
    form.append('pageCount', pageCount);
  }
  form.append('file', file);
  let response = await axiosCall('post', url, form);
  return response.data;
};

export const createHybridBatch = async (payload) => {
  const query = buildQueryParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/createBatch${query ? `?${query}` : ''}`;
  let response = await axiosCall('post', url);
  return response.data;
};

export const getHybridQueueList = async (payload) => {
  const query = new URLSearchParams(payload).toString();
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/queue/list${query ? `?${query}` : ''}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const createQueueBatch = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/queue/createBatch`;
  let response = await axiosCall('post', url, payload);
  return response.data;
};

export const viewFile = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}hybrid/queue/view?queueId=${payload}`;
  let response = await axiosCall('get', url);
  return response;
};